var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.823,
    height: 37.823,
    viewBox: "0 0 37.823 37.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174088",
    "data-name": "Group 174088",
    transform: "translate(-1.076 -53.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168709",
    "data-name": "Path 168709",
    d: "M18.912,0A18.912,18.912,0,1,1,0,18.912,18.912,18.912,0,0,1,18.912,0Z",
    transform: "translate(1.076 53.054)",
    fill: "#f7a220"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_2_",
    "data-name": "eye (2)",
    transform: "translate(10.625 66.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168710",
    "data-name": "Path 168710",
    d: "M9.362,98.725c-3.577,0-6.822,1.957-9.216,5.136a.741.741,0,0,0,0,.885c2.394,3.183,5.638,5.14,9.216,5.14s6.822-1.957,9.216-5.136a.741.741,0,0,0,0-.885C16.184,100.682,12.939,98.725,9.362,98.725Zm.257,9.51a3.938,3.938,0,1,1,3.673-3.673A3.941,3.941,0,0,1,9.619,108.235ZM9.5,106.42a2.121,2.121,0,1,1,1.98-1.98A2.117,2.117,0,0,1,9.5,106.42Z",
    transform: "translate(0 -98.725)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.0e587073d8c288ff7fd8d6e74eaf6315.svg";
export { ForwardRef as ReactComponent };